import { Color, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { TooltipProps } from 'recharts'
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent'

import { useSalesReportStatistics } from '../../../../contexts/salesReportStatisticsContext'
import { SalesReportGraphData } from '../../../../types/salesReportGraphData'
import { SalesReportGraphTooltipBox } from './elements/SalesReportGraphTooltipBox'
import * as Styled from './styles'

export const SalesReportGraphTooltip = ({
  active,
  payload,
}: TooltipProps<ValueType, NameType>): null | ReactElement => {
  const { t } = useTranslation()
  const { shouldShowUnpaid } = useSalesReportStatistics()
  if (!active || !payload?.length) {
    return null
  }

  // double payload here because we're using stacked graph, it's an array of payloads
  const graphData: SalesReportGraphData = payload?.[0].payload

  if (!graphData) {
    return null
  }

  const tooltip = graphData?.display?.tooltip
  const { paid, unpaid } = graphData.displayValues

  return (
    <Styled.CustomTooltipWrapper>
      <Flex flexDirection="column" gap={Spacing.S8}>
        <Styled.CustomTooltipTitle>
          <Text colorVariant="placeholder" weight="bold" alignment="left">
            {tooltip}
          </Text>
        </Styled.CustomTooltipTitle>
        <SalesReportGraphTooltipBox color={Color.Green400} value={paid}>
          {t('sales_report.statistics.graph.invoices.paid')}
        </SalesReportGraphTooltipBox>
        {shouldShowUnpaid && (
          <SalesReportGraphTooltipBox color={Color.Grey200} value={unpaid}>
            {t('sales_report.statistics.graph.invoices.unpaid')}
          </SalesReportGraphTooltipBox>
        )}
      </Flex>
    </Styled.CustomTooltipWrapper>
  )
}
